import { useFlags } from "launchdarkly-react-client-sdk";
import { useResourcePermission } from "src/components/permission/use-resource-permission";

type Props = {
  sourceId?: string;
};

export const useCanAccessEventSourceData = ({ sourceId }: Props) => {
  const { eventsRbacEnabled } = useFlags();
  const shouldGateDebugger = eventsRbacEnabled && Boolean(sourceId);
  const permission =
    shouldGateDebugger && sourceId
      ? {
          v2: {
            resource: "event_source" as const,
            grant: "can_access_data" as const,
            id: sourceId,
          },
        }
      : undefined;

  const { isPermitted, isLoading } = useResourcePermission(permission);

  return {
    shouldGateDebugger,
    canAccessData: !shouldGateDebugger || isPermitted,
    isLoading: shouldGateDebugger && isLoading,
  };
};
